module.exports = __webpack_public_path__ + "static/mozfest-presentator-e651614324516f5bd75858a35c868347.jpg";